import React from "react";
import {
    Form,
    FormElement,
    FormValidator,
    CustomTextControl,
    BaseReactComponent,
    FormSubmitButton,
    SelectControl,
} from "../../../utils/form";
import { Row, Col } from "react-bootstrap";
import { CustomModal, Spinner } from "../../common";
import { addObjectiveApi, updateObjectiveApi } from './../Api';
import { getAllSsoPartnersApi } from "../../sso/Api";
import { isPartnerAllowed } from "../../../utils/ReusableFunctions";
import { isModuleExist, MODULE_ID_MAP } from "../../../utils/Constant";

class ObjectiveForm extends BaseReactComponent {
    constructor(props) {
        super(props);
        const data = props.editData || null;
        const AccesData = isModuleExist(MODULE_ID_MAP.AutoShareObjective);
        let partners = this.loadDefaultPartners(AccesData)
        if (data?.partners?.list) {
            partners = data?.partners
        }
        this.state = {
            AccessData: AccesData,
            isAddContent: true,
            partners,
            objective: data?.objective || "",
            description: data?.description || "",
            isPaid: data?.uuid ? (data?.isPaid ? "true" : "false") : "",
            resLoading: false,
        };
    }

    componentDidMount() {
        getAllSsoPartnersApi(this);

    }
    onValidSubmit = () => {
        this.setState({ resLoading: true })
        let data = {
            "data": {
                "objective": this.state.objective,
                "description": this.state.description || "",
                "isPaid": this.state.isPaid === "true",
                'partners': this.state.partners,
            },
        };
        if (!isPartnerAllowed(this.state.AccessData?.id)) {
            delete data.data.partners;
        }
        if (this.props.editData?.uuid) {
            updateObjectiveApi(JSON.stringify(data), this.props.this, this.props.onHide, this.props.editData.uuid, this)
        } else {
            addObjectiveApi(JSON.stringify(data), this.props.this, this.props.onHide, this);
        }

    };
    render() {
        return (
            <CustomModal
                show={this.props.show}
                onHide={this.props.onHide}
                title={this.props.editData?.uuid ? "Edit Objective" : "Add Objective"}
                modalClass={"change-password"}
            >
                <Form onValidSubmit={this.onValidSubmit}>
                    <Row>
                        {isPartnerAllowed(this.state.AccessData?.id) &&
                            <Col md={6}>
                                <FormElement
                                    valueLink={this.linkState(this, "partners.list")}
                                    label="Publish To Partner(s)"
                                    required
                                    validations={[
                                        {
                                            validate: FormValidator.isRequired,
                                            message: "Publish To cannot be empty",
                                        },
                                    ]}
                                    control={{
                                        type: SelectControl,
                                        settings: {
                                            options: this.state?.ssoPartnersOptions || [],
                                            placeholder: "Select Partner(s)",
                                            multiple: true,
                                            searchable: true,
                                            selectAll: true,
                                            onChangeCallback: (onBlur) => {
                                            },
                                        },
                                    }}
                                />

                            </Col>}
                    </Row>
                    <Row>

                        <Col sm={6}>
                            <FormElement
                                valueLink={this.linkState(this, "objective")}
                                label="Objective Name"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Field cannot be empty",
                                    },
                                ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        //   type: "",
                                        placeholder: "Enter Objective Name",
                                    },
                                }}
                            />
                        </Col>
                        <Col sm={6}>
                            <FormElement
                                valueLink={this.linkState(this, "isPaid")}
                                label="Is Paid"
                                control={{
                                    type: SelectControl,
                                    settings: {
                                        options: [
                                            { value: "true", label: "Yes" },
                                            { value: "false", label: "No" },
                                        ],
                                        placeholder: "Select is Paid",
                                    },
                                }}
                            />
                        </Col>
                        <Col sm={12}>
                            <FormElement
                                valueLink={this.linkState(this, "description")}
                                label="Description"
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        as: "textarea",
                                        rows: 3,
                                        placeholder: "Enter Description",
                                    },
                                }}
                            />
                        </Col>
                    </Row>
                    <div className="submit-wrapper" style={{ justifyContent: "center" }}>
                        <FormSubmitButton customClass={"primary-btn"}>
                            {this.state.resLoading ? <span className="d-flex align-items-center gap-12"> <Spinner /> Saving...</span> : "Save"}
                        </FormSubmitButton>
                    </div>
                </Form>
            </CustomModal>
        );
    }
}

export default ObjectiveForm;
